  <div style="display: flex;align-items: center;" *ngIf="available?.length > 1">
    <p class="select-label">{{label}} </p>
  <p-select ngDefaultControl placeholder="Select Instance"  [options]="available" [(ngModel)]="selectedValue" optionLabel="title"/>
  </div>